import React from 'react';
import PropTypes from 'prop-types';
import { Checkbox } from 'react-icheck';
import { Col, FormGroup, ControlLabel, HelpBlock } from 'react-bootstrap';
import 'icheck/skins/minimal/grey.css';

const CustomCheckbox = ({ horizontal, checkboxClass, required, labelCol = 3, valueCol = 9, input, label, help, meta: { touched, error, warning }, entries, inline, ...props }) => {
	const validationState = touched && (error && "error") || (warning && "warning") || null;

	const classes = checkboxClass || 'icheckbox_minimal-grey bg';

	const checkedValues = new Set(input.value || []);
	const entryOnChange = (value, checked) => {
		if (checked) {
			checkedValues.add(value);
		} else {
			checkedValues.delete(value);
		}
		input.onChange([...checkedValues]);
	};

	const formControls = entries && entries.map((x, index) => <div style={inline && { float: 'left', marginRight: '20px' }}>
		<Checkbox key={index} checkboxClass={classes} increaseArea='20%' label={x.label}
			onChange={e => entryOnChange(x.value, e.target.checked)} checked={checkedValues.has(x.value)} {...props} />
	</div>);
	const errorBlock = touched && (error || warning) && <HelpBlock>{error || warning}</HelpBlock>;
	const helpBlock = help && <HelpBlock>{help}</HelpBlock>;
	const labelHint = required && <em style={{ color: '#D62229' }}>*</em>;

	if (horizontal) {
		return (
			<FormGroup validationState={validationState} className='row'>
				<Col componentClass={ControlLabel} sm={labelCol}>
					{label}{labelHint}
				</Col>
				<Col sm={valueCol} componentClass={ControlLabel/*move checkboxes down to the label level*/}>
					{formControls}
					{errorBlock}
					{helpBlock}
				</Col>
			</FormGroup>);
	}

	return (
		<FormGroup validationState={validationState}>
			{formControls}
			{errorBlock}
			{helpBlock}
		</FormGroup>
	);
};

CustomCheckbox.propTypes = {
	horizontal: PropTypes.bool,
	checkboxClass: PropTypes.string,
	input: PropTypes.object,
	label: PropTypes.string,
	help: PropTypes.string,
	meta: PropTypes.object,
	disabled: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
	componentClass: PropTypes.string,
	value: PropTypes.string
};

export default CustomCheckbox;